"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _request = _interopRequireDefault(require("../../request"));
// 销售区域管理模块
var _default = exports.default = {
  getList: function getList(data, cancelToken) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/areaRefSrInfo/list',
      method: 'post',
      data: data,
      cancelToken: cancelToken
    });
  },
  syncData: function syncData(data) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/areaRefSrInfo/store/import',
      method: 'post',
      data: data
    });
  },
  import: function _import(data) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/areaRefSrInfo/import',
      method: 'post',
      data: data
    });
  },
  export: function _export(data) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/areaRefSrInfo/export',
      method: 'post',
      data: data,
      responseType: 'blob'
    });
  },
  exportRegion: function exportRegion(data) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/areaRefSrInfo/export/region',
      method: 'post',
      data: data,
      responseType: 'blob'
    });
  }
};